import useSWR from 'swr';

import { IDetailResponse, IPaginatedResponse } from 'utils/types';

import { fetcher } from './utils';

type TagStatus = 'active';

export interface ITag {
  id?: number;
  name: string;
  state?: TagStatus;
  description: string;
}

export const useTagList = (params: Record<string, any> = { size: 1000 }) => {
  const url = '/v4/dash/simple/tags';

  const { data, isLoading, error, mutate, isValidating } = useSWR<IPaginatedResponse<ITag>>(
    { url, params },
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading, error, mutate, isValidating };
};

export const useTag = (id?: number | null) => {
  const { data, isLoading, error, mutate, isValidating } = useSWR<IDetailResponse<ITag>>(
    id ? `/v4/dash/tags/${id}` : null,
    fetcher
  );

  return { data: data?.data, isLoading, error, mutate, isValidating };
};

const fetchTagsByIds = async (ids: Array<number | string>) => {
  const responses = await Promise.all(
    ids.map(id => fetcher(`/v4/dash/tags/${id}`) as Promise<IDetailResponse<ITag>>)
  );

  return responses.map(response => response.data);
};

export const useTagsByIds = (ids?: Array<number | string> | null) => {
  const shouldFetch = Boolean(ids?.length);
  const key = shouldFetch ? ['tagsByIds', ...(ids as Array<number | string>)] : null;

  const { data, isLoading, error, mutate, isValidating } = useSWR<ITag[]>(key, () =>
    fetchTagsByIds(ids as Array<number | string>)
  );

  return { data, isLoading, error, mutate, isValidating };
};
